import { createContext } from "react";

export interface ISidebarContext {
    isCollapse: boolean
    setIsCollapse: React.Dispatch<React.SetStateAction<boolean>>
}

const sidebarContext = createContext<ISidebarContext | null>(null)

export default sidebarContext